import React from "react";

const ProductPropertyContext = React.createContext();

export { ProductPropertyContext };